import PageHeader from "@/components/PageHeader";
import Services from "@/components/Services";

export default function ServicePage() {
  return (
    <>
      <PageHeader
        overline="Serviceleistungen"
        title="Ihr Fahrzeug in den"
        accent="Händen von Experten."
        subtitle="MFK-Vorbereitung, Reparatur, Beratung und Feineinstellung — Sicherheit und Werterhalt aus einer Hand."
      />
      <Services />
    </>
  );
}
